// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/declared-distances.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/declared-distances/declared-distances.js';

mount([g0]);
